import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBubble2"><Path d="M5.75195 3.75H18.252C19.9088 3.75 21.252 5.09315 21.252 6.75V15.25C21.252 16.9069 19.9088 18.25 18.252 18.25H12.002L7.00195 21V18.25H5.75195C4.0951 18.25 2.75195 16.9069 2.75195 15.25V6.75C2.75195 5.09315 4.0951 3.75 5.75195 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBubble2;
